import { loadDefaultJapaneseParser } from "budoux";
export default () => {
  const parser = loadDefaultJapaneseParser();

  const elems = document.querySelectorAll("[data-budoux]");
  elems.forEach((elem) => {
    parser.applyElement(elem);
  });
};
